import dayjs from '../../../../utils/dayjs';

export const generateDailyActivity = () => {
  const dailyActivity = [];
  const daysQuantity = 35;
  for (let i = 0; i < daysQuantity; i++) {
    const winRatio = Math.floor(Math.random() * 100);
    const matches = winRatio * Math.floor(Math.random() * 20);
    dailyActivity.push({
      date: dayjs().subtract(daysQuantity - i, 'days').unix(),
      matches,
      winRatio,
      avgPerformance: winRatio,
    });
  }
  return dailyActivity;
};

export const rocketLeagueStatsMock = {
  general: {
    playerName: 'RocketLeagueName',
    matches: 2783,
    wins: 10581,
    winRatio: 43,
    avgPerformance: 43,
    goalsPerGame: 13,
    savesPerGame: 13,
    mvpWinShare: 52.56,
    tier: 'gold',
    rank: 'III',
    division: 'I',
    rankQueue: '3v3-solo',
    queues: {
      '1v1': {
        tier: 'Unranked',
        rank: 'I',
        division: 'I',
        matches: 0,
        lastSeason: {
          tier: 'Unranked',
          rank: 'I',
          division: 'I',
        },
      },
      '2v2': {
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
        matches: 1565,
        lastSeason: {
          tier: 'Gold',
          rank: 'I',
          division: 'I',
        },
      },
      '3v3-solo': {
        tier: 'Grand Champion',
        rank: 'I',
        division: 'I',
        matches: 984,
        lastSeason: {
          tier: 'Platinum',
          rank: 'I',
          division: 'I',
        },
      },
      '3v3': {
        tier: 'Platinum',
        rank: 'I',
        matches: 502,
        division: 'I',
        lastSeason: {
          tier: 'Gold',
          rank: 'I',
          division: 'I',
        },
      },
    },
    others: {
      mvpWinShare: 52.72,
      goalsPerGame: 5.83,
      savesPerGame: 6.18,
    },
  },
  activity: {
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      hoursPlayed: 7,
      change: 120,
    },
    monthActivity: {
      hoursPlayed: 120,
      change: 94,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
        tier: 'Unranked',
        rank: 'I',
        division: 'I',
      }, {
        date: '1599868800',
        score: 0,
        tier: 'Unranked',
        rank: 'I',
        division: 'I',
      }, {
        date: '1600473600',
        score: 70,
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
      }, {
        date: '1601078400',
        score: 10,
        tier: 'Platinum',
        rank: 'I',
        division: 'II',
      }, {
        date: '1601683200',
        score: 80,
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
      }, {
        date: '1602288000',
        score: 10,
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
      }, {
        date: '1602892800',
        score: 40,
        tier: 'Grand Champion',
        rank: 'I',
        division: 'I',
      },
    ],
  },
  rank: {
    overrall: 10,
    hub: 10,
    state: 14,
    country: 33,
  },
};

export const rocketLeagueStatsMock2 = {
  general: {
    playerName: 'RocketLeagueName',
    matches: 2783,
    wins: 3040,
    winRatio: 55,
    avgPerformance: 55,
    goalsPerGame: 6,
    savesPerGame: 15,
    mvpWinShare: 43.32,
    tier: 'gold',
    rank: 'III',
    division: 'I',
    rankQueue: '3v3-solo',
    queues: {
      '1v1': {
        tier: 'Gold',
        rank: 'I',
        division: 'I',
        matches: 46,
        lastSeason: {
          tier: 'Unranked',
          rank: 'I',
          division: 'I',
        },
      },
      '2v2': {
        tier: 'Diamond',
        rank: 'II',
        division: 'IV',
        matches: 1565,
        lastSeason: {
          tier: 'Platinum',
          rank: 'I',
          division: 'I',
        },
      },
      '3v3-solo': {
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
        matches: 984,
        lastSeason: {
          tier: 'Platinum',
          rank: 'I',
          division: 'I',
        },
      },
      '3v3': {
        tier: 'Gold',
        rank: 'I',
        matches: 502,
        division: 'I',
        lastSeason: {
          tier: 'Platinum',
          rank: 'I',
          division: 'I',
        },
      },
    },
    others: {
      mvpWinShare: 52.72,
      goalsPerGame: 5.83,
      savesPerGame: 6.18,
    },
  },
  activity: {
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      hoursPlayed: 56,
      change: 20,
    },
    monthActivity: {
      hoursPlayed: 150,
      change: 33,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
        tier: 'Unranked',
        rank: 'I',
        division: 'I',
      }, {
        date: '1599868800',
        score: 0,
        tier: 'Unranked',
        rank: 'I',
        division: 'I',
      }, {
        date: '1600473600',
        score: 70,
        tier: 'Silver',
        rank: 'I',
        division: 'I',
      }, {
        date: '1601078400',
        score: 10,
        tier: 'Silver',
        rank: 'I',
        division: 'II',
      }, {
        date: '1601683200',
        score: 80,
        tier: 'Gold',
        rank: 'I',
        division: 'I',
      }, {
        date: '1602288000',
        score: 10,
        tier: 'Platinum',
        rank: 'I',
        division: 'I',
      }, {
        date: '1602892800',
        score: 40,
        tier: 'Diamond',
        rank: 'I',
        division: 'I',
      },
    ],
  },
  rank: {
    overrall: 10,
    hub: 10,
    state: 14,
    country: 33,
  },
};

export class RocketLeaguePlayerData {
  constructor(data = {}) {
    this.general = data.general || false;
    this.queues = data.queues || false;
    this.activity = data.activity || false;
    this.rank = data.rank || false;
    this.rankProgression = data.rankProgression || false;
  }
}
